// import { debug } from "util";

//Remove Polyfill
(function (arr) {
    arr.forEach(function (item) {
      if (item.hasOwnProperty('remove')) {
        return;
      }
      Object.defineProperty(item, 'remove', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function remove() {
          if (this.parentNode !== null)
            this.parentNode.removeChild(this);
        }
      });
    });
  })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

const popUpFunction = () => {
    (function($){
        $('.popup_box, .popup_cta').magnificPopup({
            type: 'inline',
            preloader: false,
            focus: '#username',
            modal: true
        });
        $(document).on('click', '.popup-modal-dismiss', function (e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
    })(jQuery);
} 

(function () {

    'use strict' 

    class Tab {

        constructor(container) {
            this.container    = container,
            this.tabList      = container.querySelector('.tabselected')
            this.tabListInner = container.querySelector('.tabselected__inner'),
            this.tabListItems = [].slice.call(container.querySelectorAll('.tabselected__item'))
            this.trigger      = container.querySelector('.tabselected__trigger')
            this.contentItems = container.querySelectorAll('.tabselected__content__item')
            this.content      = container.querySelector('.tabselected__content')
            this.handleClick = this.handleClick.bind(this);
        }

        registerEvents() {
            this.container.addEventListener('click', this.handleClick)
        }

        handleClick(e) {
            let el = e.target

            if (el.classList.contains('tabselected__trigger'))
                return this.toggleSelectArea()

            if (el.classList.contains('tabselected__item'))
                return this.handleSelect(el)

            if (el.classList.contains('tabselected__tablist__item'))
                return this.handleCheckbox(el)

            if (el.classList.contains('tabselect__submit__btn')) {
                e.preventDefault();
                return this.handleSubmit(el)
            }
            
        }

        handleCheckbox(el) {

            let data    = el.getAttribute('data-file'),
                url     = 'https://www.gironde-habitat.fr/wp-content/themes/gironde-habitat/form/' + data + '.php',
                target  = document.querySelector('.tabselected__tabcontent'),
                current = document.querySelector('.tabselected__tablist__item.trigger')

            if (el === current) return

            let httpRequest = new XMLHttpRequest();

            httpRequest.open('GET', url, true);
            httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            httpRequest.send();
    
            httpRequest.onreadystatechange = function () {
                if (httpRequest.readyState == XMLHttpRequest.DONE) {
                    if (httpRequest.status == 200) {
                        let div = document.createElement('div');
                        div.innerHTML = httpRequest.responseText
                        sessionStorage[url] = target.innerHTML = div.querySelector('.my__content').innerHTML

                        document.querySelector('.tabselected__tablist__item.trigger').classList.remove('trigger')
                        el.classList.add('trigger')

                        return
                    } else {
                        console.log('Something went wrong inside matrice')
                    }
                }
            };

            // let xhr = new XMLHttpRequest()
            // if (!xhr) return

            // this.makeRequest(url, target)
            //     .then(() => {
            //         document.querySelector('.tabselected__tablist__item.trigger').classList.remove('trigger')
            //         el.classList.add('trigger')
            //     })
            //     .catch((error) => {
            //         console.log('Checkbox : Something went wront inside the matrice : ', error)
            //     })
        }

        handleSelect(el) {
            
            let data    = el.getAttribute('data-file'),
                url     = 'https://www.gironde-habitat.fr/wp-content/themes/gironde-habitat/form/' + data + '.php',
                target  = document.querySelector('.tabselected__content'),
                current = this.tabListInner.querySelector('.tabselected__item.trigger')

            if (current && el === current) return

            //TEST//
            let httpRequest = new XMLHttpRequest();

            httpRequest.open('GET', url, true);
            httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            httpRequest.send();
    
            httpRequest.onreadystatechange = function () {
                if (httpRequest.readyState == XMLHttpRequest.DONE) {
                    if (httpRequest.status == 200) {
                        let div = document.createElement('div');
                        div.innerHTML = httpRequest.responseText
                        sessionStorage[url] = target.innerHTML = div.querySelector('.my__content').innerHTML

                        if(document.querySelector('.tabselected__inner').classList.contains('triggered')){
                            document.querySelector('.tabselected__inner').classList.remove('triggered')
                        }

                        document.querySelector('.tabselected__trigger__baseline').innerHTML = "<b>" + el.innerText + "</b>"

                        if (current) {
                            current.classList.remove('trigger')
                        }                            
                        
                        // this.tabListInner.classList.remove('triggered')
                        // this.trigger.classList.remove('triggered')
                        // el.classList.add('trigger')
                        // this.trigger.querySelector('.tabselected__trigger__baseline').innerHTML = el.innerHTML                            

                        popUpFunction();
                        return
                    } else {
                        console.log('Something went wrong inside matrice')
                    }
                }
            };
            //END TEST//

            // let xhr = new XMLHttpRequest()
            // if (!xhr) return

            // this.makeRequest(url, target)
            //     .then(() => {

            //         if (current)
            //             current.classList.remove('trigger')
                    
            //         this.tabListInner.classList.remove('triggered')
            //         this.trigger.classList.remove('triggered')
            //         el.classList.add('trigger')
            //         this.trigger.querySelector('.tabselected__trigger__baseline').innerHTML = el.innerHTML
            //         popUpFunction();
            //     })
            //     .catch((error) => {
            //         console.log('Select : Something went wrong inside matrice : ', error)
            //     })
        }

        makeRequest(url, target) {

            let xhr = new XMLHttpRequest()
            if (!xhr) return 

            return new Promise((resolve, reject) => {
                xhr.responseType = 'document'
                xhr.onload = () => {
                    sessionStorage[url] = target.innerHTML = xhr.response.querySelector('.my__content').innerHTML
                    resolve(xhr)
                }
                xhr.open('POST', url, true)
                xhr.send()
            })
        }

        toggleSelectArea() {
            this.trigger.classList.toggle('triggered')
            this.tabListInner.classList.toggle('triggered')
        }

        selectItem(currentBtn, currentContent, contentItem, el) {

            currentContent.classList.remove('trigger')
            currentBtn.classList.remove('trigger')

            contentItem.classList.add('trigger')
            el.classList.add('trigger')
        }

        handleSubmit(el) {

            let form   = document.querySelector('form.js__send__form'),
                fields = form.querySelectorAll('input, textarea'),
                tabSelect = document.querySelector('.tabselected'),
                topic = document.querySelector('.tabselected__trigger__baseline').innerHTML,
                data = new FormData(form),
                xhr = new XMLHttpRequest();
            
            if (!xhr) return

            if(topic == "<b>Votre demande concerne</b>"){
                let pError = document.createElement('p');
                pError.innerText = "Veuillez renseigner l'objet de votre demande";
                pError.className = "field--alert alert-topic";
                tabSelect.appendChild(pError);
            } else {
                let alert = document.querySelector('.alert-topic')
                if(alert){
                    alert.remove();
                }
            }

            this.checkField(fields)

            if (document.querySelector('.field--alert')){
                return this.alertSubmit();
            }

            let submitErrorMsg = document.querySelector('.submit__error')
            if (submitErrorMsg) submitErrorMsg.remove()

            xhr.onreadystatechange = () => {
                if (xhr.readyState !== 4) return

                if (xhr.status >= 200 && xhr.status < 300) {
                    let submit = document.querySelector('.tabselect__submit__btn'),
                        el     = document.createElement('p')
                    el.className = 'success__msg'
                    el.innerHTML = 'Merci pour votre message, nous allons traiter votre demande au plus vite.'
                    
                    submit.parentElement.appendChild(el)
                    submit.remove();
                    window.location.href="https://www.gironde-habitat.fr/confirmation/?type=4";
                }
                else {
                    let submit = document.querySelector('.tabselect__submit__btn'),
                        el     = document.createElement('p')
                    el.className = 'submit_error'
                    el.innerHTML = 'Oups ! Excusez-nous mais une erreur interne est survenue. Veuillez réessayer un peu plus tard.'
                    console.log('Something went wrong in the upside down', error)
                }
            }

            xhr.open('POST', form.getAttribute('action'), true)
            xhr.setRequestHeader('X-Requested-with', 'xmkhttprequest')
            xhr.send(data)
        }

        alertSubmit() {
            let submit = document.querySelector('.tabselect__submit__btn'),
                el     = document.createElement('p')
            el.className = 'submit__error'
            el.innerHTML = 'Oups ! Un ou plusieurs champs sont incorrects'
            submit.parentElement.appendChild(el)
        }

        checkField(fields) {

            for (let i=0; i<fields.length; i++) {
                
                let field = fields[i]

                if (field.type === 'file'){
                    let fileAlert = document.querySelector('.tabselected__field__file .field--alert'),
                        fileField = document.querySelector('.tabselected__field__file'),
                        fileTypes = ['image/jpeg','image/pjpeg','image/png','application/pdf','application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
                        el = document.createElement('p');
                    
                    el.className = 'field--alert';

                    if(fileAlert != undefined)
                        fileAlert.remove();

                    if(field.files[0] != undefined){
                        if (field.files[0].size >= 2000000){
                            el.innerText = 'Le fichier est trop volumineux. (il doit être inférieur à 2Mb)';
                            fileField.appendChild(el);
                        }
    
                        if (!fileTypes.includes(field.files[0].type)){
                            el.innerText = 'Le format du fichier est incorrect. (doc, docx, pdf, jpg, png)';
                            fileField.appendChild(el);
                        }
                    }
                }

                if (field.type === 'radio')
                    continue

                if (field.type === 'checkbox' && field.getAttribute('name') === 'rgpd' && !field.checked) {
                    this.handleAlert(field, true, 'Merci d\'accepter les conditions.')
                }

                if (field.getAttribute('name') === 'quote') {
                    if (!field.value) continue;

                    let submit = document.querySelector('.tabselect__submit__btn'),
                        el     = document.createElement('p')
                    el.className = 'field--alert'
                    el.innerHTML = 'Votre message est detecté comme étant celui d\'un bot, et donc impossible à envoyer, merci de réessayer plus tard.'
                    submit.parentElement.appendChild(el)
                }

                if (field.type === 'email') {
                    this.handleAlert(field, true, 'Le format est incorrect. Ex: contact@example.com');
                    continue;
                }

                if (field.type === 'tel') {
                    this.handleAlert(field, true, 'Le format est incorrect. Ex: 0559515253 ou +33651525152')
                }
                this.handleAlert(field)
            }
        }

        handleAlert(field, checkFormat=false, formatStr=false) {

            if (field.type === 'checkbox') {
                if (field.checked) {
                    if (field.parentElement.classList.contains('field--empty')) {
                        field.parentElement.classList.remove('field--empty')
                        field.parentElement.querySelector('.field--alert').remove()
                    }
                } else {
                    if (field.parentElement.classList.contains('field--empty'))
                        return
                    
                    let el = document.createElement('p')
                    el.className = 'field--alert'
                    el.innerHTML = 'Veuillez accepter les conditions.'
                    field.classList.add('field--empty')

                    if (!field.parentElement.classList.contains('field--empty'))
                        field.parentElement.classList.add('field--empty')

                    return field.parentElement.appendChild(el)
                }
                return 
            }
            
            if (!field.value && !field.classList.contains('field--empty')) {
                let el = document.createElement('p')
                el.className = 'field--alert'
                el.innerHTML = 'Ce champ est obligatoire'
                field.classList.add('field--empty')

                if (field.classList.contains('field--error')) {
                    field.classList.remove('field--error')
                    field.parentElement.querySelector('.field--alert').remove()
                }

                return field.parentElement.appendChild(el)
            }

            if (field.value && field.classList.contains('field--empty')) {
                field.classList.remove('field--empty')
                field.parentElement.querySelector('.field--alert').remove()
            }

            if (!checkFormat) return
            
            let regex;

            switch (field.type) {
                case 'email': 
                    regex = /[^\s@]+@[^\s@]+\.[^\s@]+/;
                    break;
                case 'tel': 
                    regex = /^((\+)33|0)[1-9](\d{2}){4}$/;
                    break;
                default:
                    break;
            }

            if (regex.test(field.value) && field.classList.contains('field--error')) {
                field.classList.remove('field--error')
                return field.parentElement.querySelector('.field--alert').remove()
            }

            if (field.value && !regex.test(field.value) && !field.classList.contains('field--error')) {
                field.classList.add('field--error')
                let el = document.createElement('p')
                el.className = 'field--alert'
                if (formatStr)
                    el.innerHTML = formatStr
                else {
                    el.innerHTML = 'Le format de ce champ est incorrect'
                }
                return field.parentElement.appendChild(el)
            }
        }
    }

    window.onload = function() {
        let tabSelect = document.querySelector('.tabselected__container');
        if (tabSelect) {
            let tabInit = new Tab(tabSelect);
            tabInit.registerEvents();
        }
    };    
})();